export function ColombiaIconInput() {
  return (
    <div className="relative flex bg-purpleLight text-tgray rounded-xl">
      <div className="w-8 h-auto bg-cover bg-no-repeat bg-center rounded-lg m-1 bg-[url('/public/png/colombia-flag.png')]" />
      <div className="py-2 px-1 pl-0 ">+57</div>
    </div>
  );
}
